module.exports = __webpack_public_path__ + "static/media/CAD.1ba6eb3d.svg";